export default __webpack_public_path__ + "static/media/gaz-de-france-logo.592ad2e3.png";